import { useQuery } from "@apollo/client";
import { BoxCoverCollection } from "core/components/BoxCoverCollection";
import { Id, config, content } from "core/utils";
import React from "react";
import { query } from "./query";
export var ComingSoonPrograms = function (_a) {
    var userInput = _a.userInput;
    var _b = useQuery(query, {
        variables: {
            size: 24,
        },
    }), data = _b.data, error = _b.error;
    if (error)
        return null;
    if (userInput.channel.current !== "all")
        return null;
    if (!data ||
        !data.getComingSoonOverviewItems ||
        data.getComingSoonOverviewItems.items.length === 0)
        return null;
    return (React.createElement(BoxCoverCollection, { componentId: Id.component.contentCollection.comingSoon, collectionComponentId: Id.component.contentCollection.comingSoon, listName: config.tracking.listNames.comingSoonPrograms, title: content.title.comingSoonPrograms, items: data.getComingSoonOverviewItems.items, trackingEnabled: !data.fetchingData }));
};
